import { jsx as _jsx } from "react/jsx-runtime";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Input } from "@faire/web--source/slate/Input";
import { trackSignupFillEmailAddressOnPreSignUpFormClick } from "@faire/web-api--source/events/signup/click/fillEmailAddressOnPreSignUpForm";
import once from "lodash/once";
import { observer } from "mobx-react";
import React, { useEffect, useRef } from "react";
var EmailInputBase = function(param) {
    var email = param.email, onContinue = param.onContinue, onBlur = param.onBlur, disabled = param.disabled, markUserEntersEmail = param.markUserEntersEmail, omitLabel = param.omitLabel;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var inputRef = useRef(null);
    var isMounted = useRef(false);
    // Handle case where user has started to enter text during SSR by updating state
    // on hydration.
    useEffect(function() {
        var _inputRef_current;
        if (isMounted.current) {
            return;
        }
        isMounted.current = true;
        var domValue = (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.value;
        if (domValue) {
            var _inputRef_current1;
            email.setValue((_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.name, domValue);
        }
    }, [
        email
    ]);
    var onChange = function(e) {
        once(function() {
            return trackSignupFillEmailAddressOnPreSignUpFormClick();
        });
        markUserEntersEmail();
        email.setValue(e.currentTarget.name, e.currentTarget.value);
    };
    var inputLabel = strictLocalize({
        id: "rTiQu/",
        defaultMessage: [
            {
                type: 0,
                value: "Business email"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(Input, {
        ref: inputRef,
        disableFlex: true,
        disabled: disabled,
        label: omitLabel ? undefined : inputLabel,
        name: "email",
        autoComplete: "email",
        value: email.value,
        error: email.error,
        onChange: onChange,
        onKeyDown: handleKeyDown(onContinue),
        onBlur: onBlur,
        "data-test-id": "email"
    });
};
export var EmailInput = observer(EmailInputBase);
